import type { ReactNode } from 'react'

import { BaseTag } from './BaseTag'

type RawTagProps = {
  text: string
  icon?: ReactNode
  onlyIcon?: boolean
  right?: ReactNode
  additionalAccessibleText?: string
  className?: string
}

export const RawTag = ({
  text,
  icon,
  onlyIcon,
  right,
  additionalAccessibleText,
  className,
}: RawTagProps) => {
  const effectiveAdditionalAccessibleText =
    onlyIcon && !additionalAccessibleText ? text : additionalAccessibleText

  return (
    <BaseTag
      left={icon}
      text={text}
      hideLabel={onlyIcon}
      right={right}
      additionalAccessibleText={effectiveAdditionalAccessibleText}
      className={className}
    />
  )
}
